import React, { Component } from 'react';
import { defaultHeaders } from './util';
import * as util from "./util";
import {
  ProductRating, ProductDetailsButtons, ProductMediaMultiParent, ProductReviews, ProductPrice,
  ProductTechnicalDetails, ProductReferenceSoftwareNew, SoftwareStatistics, ProductDescriptionResearchSoftware
,ProductTypeWithoutParantheses, ProductTypeWithLabel} from './product-details';
import {Header} from './header.js';
import {Footer} from './footer.js';
import { CategoryPathWithLabel} from './show-categorypath.js';
import './product-details.css';

let faqProductDetails = [
  {
    content: "Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",
    title: "Nicht fündig geworden?",
    key: 0
  }
];

export class ResearchSoftwareDetails extends Component {
  constructor(props) {
    super(props);
    this.getResearchSoftwareDetails = this.getResearchSoftwareDetails.bind(this);

    this.state = {
      id: this.props.match.params.id,
      name: '',
      type:"Software F+L",
      board: '',
      uuid: '',
      categories: '',
      desc: '',
      price: 0,
      researchtype: '',
      aim: '',
      functionality: '',
      specialties: '',
      target: '',
      usage: '',
      tags: '',
      standalone_sw: '',
      is_standalone_sw: '',
      agreement: false,
      direct_database_access: null,
      direct_database_access_desc: '',
      has_additional_interface: null,
      additional_interface: '',
      has_additional_licence: null,
      additional_licence: '',
      data_component_complete: '',
      data_component_options: '',
      data_manipulation: '',
      data_manipulation_protocol: '',
      manipulation_authorised: null,
      manipulation_authorised_desc: '',
      data_update_interval: 0,
      has_update_side_effect: '',
      update_side_effect: '',
      has_release_plan: '',
      release_plan: '',
      is_preparation_needed: '',
      preparation_needed: '',
      has_customer_reference: '',
      customer_reference: '',
      successful_deployment: null,
      successful_deployment_description: '',
      clinic_desc: '',
      clinic_number: 0,
      user_number: 0,
      complexity_rate: 0,
      satisfaction_rate: 0,
      date: '',
      rating_desc: '',
      pdf_files: '',
      image_files: '',
      video_files: '',
    }

    if (!util.isCommercialUser() && !util.isNonCommercialUser() && this.id !== undefined) {
      util.loginGuest( () => this.getResearchSoftwareDetails(this.props.match.params.id) );
    } else {
      this.getResearchSoftwareDetails(this.props.match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const newID = parseInt(nextProps.match.params.id, 10);
    const oldID = parseInt(this.state.id, 10);
    if (oldID !== newID) {
      this.getResearchSoftwareDetails(newID);
      this.setState({ id: newID });
    }
  }

  getResearchSoftwareDetails(id) {
    const self = this;
    const url = `/api/show-researchsoftware?id=${id}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
        .catch(function (exception) {
          alert('Software details konnten nicht geladen werden.');
          console.error('Could not software details.', exception);
        });

    promise.then(function (json) {
      localStorage.setItem('product-name', json.name);
      self.setState({
        name: (json.name ? json.name : '(kein Name)'),
        board: json.board ? json.board : '',
        uuid: json.uuid ? json.uuid : '',
        categories: (json.categories ? json.categories : '(keine Angabe)'),
        desc: (json.desc ? json.desc : '(keine Angabe)'),
        price: (json.price !== undefined ? json.price : '(keine Angabe)'),
        researchtype: (json.researchtype ? json.researchtype : '(keine Angabe)'),
        aim: (json.aim ? json.aim : '(keine Angabe)'),
        functionality: (json.functionality ? json.functionality : '(keine Angabe)'),
        specialties: (json.specialties ? json.specialties : '(keine Angabe)'),
        target: (json.target ? json.target : '(keine Angabe)'),
        usage: (json.usage ? json.usage : '(keine Angabe)'),
        tags: (json.tags ? json.tags : '(keine Angabe)'),
        standalone_sw: (json.standalone_sw ? json.standalone_sw : '(keine Angabe)'),
        is_standalone_sw: (json.is_standalone_sw ? json.is_standalone_sw : '(keine Angabe)'),
        direct_database_access: (json.direct_database_access ? json.direct_database_access : '(keine Angabe)'),
        direct_database_access_desc: (json.direct_database_access_desc ? json.direct_database_access_desc : '(keine Angabe)'),
        has_additional_interface: (json.has_additional_interface ? json.has_additional_interface : '(keine Angabe)'),
        additional_interface: (json.additional_interface ? json.additional_interface : '(keine Angabe)'),
        has_additional_licence: (json.has_additional_licence ? json.has_additional_licence : '(keine Angabe)'),
        additional_licence: (json.additional_licence ? json.additional_licence : '(keine Angabe)'),
        data_component_complete: (json.data_component_complete ? json.data_component_complete : '(keine Angabe)'),
        data_component_options: (json.data_component_options ? json.data_component_options : '(keine Angabe)'),
        data_manipulation: (json.data_manipulation ? json.data_manipulation : '(keine Angabe)'),
        data_manipulation_protocol: (json.data_manipulation_protocol ? json.data_manipulation_protocol : '(keine Angabe)'),
        manipulation_authorised: (json.manipulation_authorised ? json.manipulation_authorised : '(keine Angabe)'),
        manipulation_authorised_desc: (json.manipulation_authorised_desc ? json.manipulation_authorised_desc : '(keine Angabe)'),
        data_update_interval: (json.data_update_interval ? json.data_update_interval : '(keine Angabe)'),
        has_update_side_effect: (json.has_update_side_effect ? json.has_update_side_effect : '(keine Angabe)'),
        update_side_effect: (json.update_side_effect ? json.update_side_effect : '(keine Angabe)'),
        has_release_plan: (json.has_release_plan ? json.has_release_plan : '(keine Angabe)'),
        release_plan: (json.release_plan ? json.release_plan : '(keine Angabe)'),
        is_preparation_needed: (json.is_preparation_needed ? json.is_preparation_needed : '(keine Angabe)'),
        preparation_needed: (json.preparation_needed ? json.preparation_needed : '(keine Angabe)'),
        has_customer_reference: (json.has_customer_reference ? json.has_customer_reference : '(keine Angabe)'),
        customer_reference: (json.customer_reference ? json.customer_reference : '(keine Angabe)'),
        successful_deployment: (json.successful_deployment ? json.successful_deployment : '(keine Angabe)'),
        successful_deployment_description: (json.successful_deployment_description ? json.successful_deployment_description : '(keine Angabe)'),
        clinic_desc: (json.clinic_desc ? json.clinic_desc : '(keine Angabe)'),
        clinic_number: (json.clinic_number ? json.clinic_number : '(keine Angabe)'),
        user_number: (json.user_number ? json.user_number : '(keine Angabe)'),
        complexity_rate: (json.complexity_rate ? json.complexity_rate : '(keine Angabe)'),
        satisfaction_rate: (json.satisfaction_rate ? json.satisfaction_rate : '(keine Angabe)'),
        date: (json.date ? json.date : '(keine Angane)'),
        rating_desc: (json.rating_desc ? json.rating_desc : '(keine Angabe)'),
        agreement: (json.agreement ? json.agreement : '(keine Angabe)'),
        pdf_files: (json.pdf_files ? json.pdf_files : '(keine Angabe)'),
        image_files: (json.image_files ? json.image_files : '(keine Angabe'),
        video_files: (json.video_files ? json.video_files : '(keine Angabe)'),

      });
      return;
    });
    return;
  }

  render() {
    return (
        <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
          <div className="productHeader1">
              {/* <ProductType name={this.state.name} productType={this.state.type} />*/}
              <ProductTypeWithoutParantheses name={this.state.name} />
            </div>

            <ProductDetailsButtons board={this.state.board} history={this.props.history} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price} onNewMessage={this.props.onNewMessage} />

        <div className="productInfoHeader">
        
        {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
        <ProductTypeWithLabel  productType={this.state.type} />
        <CategoryPathWithLabel ids={this.state.categories} startID={2} />
        <ProductRating uuid={this.state.uuid} />
        {!util.isGuestUser() && <ProductPrice price={this.state.price} />}
        
        </div>
       
        <ProductTabsResearchSoftware
      //description tab
      onNewMessage={this.props.onNewMessage}
      uuid={this.state.uuid}
      desc={this.state.desc}
      is_standalone_sw={this.state.is_standalone_sw}
      standalone_sw={this.state.standalone_sw}
      aim={this.state.aim}
      researchtype={this.state.researchtype}
      functionality={this.state.functionality}
      specialties={this.state.specialties}
      target={this.state.target}
      usage={this.state.usage}
      tags={this.state.tags}
      //technical details
      direct_database_access={this.state.direct_database_access}
      direct_database_access_desc={this.state.direct_database_access_desc}
      has_additional_interface={this.state.has_additional_interface}
      additional_interface={this.state.additional_interface}
      has_additional_licence={this.state.has_additional_licence}
      additional_licence={this.state.additional_interface}
      data_component_complete={this.state.data_component_complete}
      data_component_options={this.state.data_component_options}
      data_manipulation={this.state.has_additional_interface}
      data_manipulation_protocol={this.state.data_manipulation_protocol}
      manipulation_authorised={this.state.manipulation_authorised}
      manipulation_authorised_desc={this.state.manipulation_authorised_desc}
      data_update_interval={this.state.data_update_interval}
      has_update_side_effect={this.state.has_update_side_effect}
      update_side_effect={this.state.update_side_effect}
      has_release_plan={this.state.has_release_plan}
      release_plan={this.state.release_plan}
      is_preparation_needed={this.state.is_preparation_needed}
      preparation_needed={this.state.preparation_needed}
      //reference software
      has_customer_reference={this.state.has_customer_reference}
      customer_reference={this.state.customer_reference}
      //statistics
      successful_deployment={this.state.successful_deployment}
      successful_deployment_description={this.state.successful_deployment_description}
      clinic_desc={this.state.clinic_desc}
      clinic_number={this.state.clinic_number}
      user_number={this.state.user_number}
      date={this.state.date}
      complexity_rate={this.state.complexity_rate}
      satisfaction_rate={this.state.satisfaction_rate}
      rating_desc={this.state.rating_desc}
      pdf_files={this.state.pdf_files}
      image_files={this.state.image_files}
      video_files={this.state.video_files}
        />
       
        <ProductDetailsButtons board={this.state.board} history={this.props.history} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price} onNewMessage={this.props.onNewMessage} />
      </div>
      </div>
      <Footer faqs={faqProductDetails} />
        </div>
    );
  }
}

class ProductTabsResearchSoftware extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
        <div className="ProductTabs">
        <div className="ProductTabsButtons">
        <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
        <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Technische Details</button>
        <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} >Referenz</button>
        <button className={this.state.activeTab === 3 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(3)} >Statistik</button>
        <button className={this.state.activeTab === 4 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(4)} >Reviews</button>
        <button className={this.state.activeTab === 5 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(5)} >Medien</button>
        <ProductDescriptionResearchSoftware style={this.state.activeTab === 0 ? null : { display: 'none' }}
      desc={this.props.desc}
      aim={this.props.aim}
      researchtype={this.props.researchtype}
      is_standalone_sw={this.props.is_standalone_sw}
      standalone_sw={this.props.standalone_sw}
      functionality={this.props.functionality}
      specialties={this.props.specialties}
      target={this.props.target}
      usage={this.props.usage}
      tags={this.props.tags} />
        <ProductTechnicalDetails style={this.state.activeTab === 1 ? null : { display: 'none' }}
      direct_database_access={this.props.direct_database_access}
      direct_database_access_desc={this.props.direct_database_access_desc}
      has_additional_interface={this.props.has_additional_interface}
      additional_interface={this.props.additional_interface}
      has_additional_licence={this.props.has_additional_licence}
      additional_licence={this.props.additional_licence}
      data_component_complete={this.props.data_component_complete}
      data_component_options={this.props.data_component_options}
      data_manupulation={this.props.data_manupulation}
      data_manupulation_protocol={this.props.data_manupulation_protocol}
      manipulation_authorised={this.props.manipulation_authorised}
      manipulation_authorised_desc={this.props.manipulation_authorised_desc}
      data_update_interval={this.props.data_update_interval}
      has_update_side_effect={this.props.has_update_side_effect}
      update_side_effect={this.props.update_side_effect}
      has_release_plan={this.props.has_release_plan}
      release_plan={this.props.release_plan}
      is_preparation_needed={this.props.is_preparation_needed}
      preparation_needed={this.props.preparation_needed}
        />
        <ProductReferenceSoftwareNew style={this.state.activeTab === 2 ? null : { display: 'none' }}
      has_customer_reference={this.props.has_customer_reference}
      customer_reference={this.props.customer_reference} />
        <SoftwareStatistics style={this.state.activeTab === 3 ? null : { display: 'none' }}
      successful_deployment={this.props.successful_deployment}
      successful_deployment_description={this.props.successful_deployment_description}
      clinic_desc={this.props.clinic_desc}
      user_number={this.props.user_number}
      clinic_number={this.props.clinic_number}
      statistic_user_counts={this.props.statistic_user_counts}
      satisfaction_rate={this.props.satisfaction_rate}
      rating_desc={this.props.rating_desc}
      date={this.props.date}
      complexity_rate={this.props.complexity_rate} />
        <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 4 ? null : { display: 'none' }}
      onNewMessage={this.props.onNewMessage} />
        <ProductMediaMultiParent style={this.state.activeTab === 5 ? null : { display: 'none' }}
      heading1={'Dokumentation'}
      uuids1={this.props.pdf_files}
      heading2={'Beschreibende Bilder oder Screenshots'}
      uuids2={this.props.image_files}
      heading3={'Video'}
      uuids3={this.props.video_files}
        />
        </div>
        <Footer faqs={faqProductDetails} />
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/researchsoftware-details.js